// in src/App.js
import {
  ErrorOutline,
  PersonOutline,
  PointOfSale,
  ReceiptOutlined,
  ShoppingCartOutlined,
  BusinessOutlined,
  History,
  LocalShipping,
} from "@mui/icons-material";

import { Admin, Resource, Layout } from "react-admin";
import "./App.css";
import { apiDataProvider } from "./providers/api.provider";
import { authProvider } from "./providers/auth.provider";
import { i18nProvider } from "./providers/i18n.provider";
import { CustomMenu } from "./components/custom-menu.component";
import * as CompaniesResource from "./resources/companies";
import * as LicensesResource from "./resources/licences";
import * as ShipmentsResource from "./resources/shipments";
import * as LogsResource from "./resources/logs";
import * as ProductsResource from "./resources/products";
import * as UsersResource from "./resources/users";
import * as AuditLogsResource from "./resources/audit-logs";
import * as OrdersResource from "./resources/orders";

const CustomLayout = (props: any) => <Layout {...props} menu={CustomMenu} />;

const App = () => (
  <Admin title="login" layout={CustomLayout} authProvider={authProvider} dataProvider={apiDataProvider} i18nProvider={i18nProvider}>
    <Resource
      name="users"
      icon={PersonOutline}
      options={{ label: "Usuários" }}
      create={UsersResource.UserCreate}
      list={UsersResource.UserList}
      edit={UsersResource.UserEdit}
    />
    <Resource
      name="licenses"
      icon={ReceiptOutlined}
      options={{ label: "Licenças" }}
      list={LicensesResource.LicenseList}
      edit={LicensesResource.LicenseEdit}
      create={LicensesResource.LicenceCreate}
    />
    <Resource
      name="shipments"
      icon={LocalShipping}
      options={{ label: "Remessas" }}
      list={ShipmentsResource.ShipmentList}
      create={ShipmentsResource.ShipmentCreate}
      edit={ShipmentsResource.ShipmentEdit}
      show={ShipmentsResource.ShipmentShow}
    />
    <Resource
      name="orders"
      icon={PointOfSale}
      options={{ label: "Pedidos" }}
      list={OrdersResource.OrderList}
      create={OrdersResource.OrderCreate}
      edit={OrdersResource.OrderEdit}
    />
    <Resource
      name="license-audit-logs"
      icon={History}
      options={{ label: "Auditoria" }}
      list={AuditLogsResource.AuditLogsList}
    />
    <Resource
      name="products"
      icon={ShoppingCartOutlined}
      options={{ label: "Produtos" }}
      create={ProductsResource.ProductsCreate}
      list={ProductsResource.ProductsList}
      edit={ProductsResource.ProductsEdit}
    />
    <Resource
      name="companies"
      icon={BusinessOutlined}
      options={{ label: "Empresas" }}
      create={CompaniesResource.CompanyCreate}
      list={CompaniesResource.CompanyList}
      edit={CompaniesResource.CompanyEdit}
      show={CompaniesResource.CompanyShow}
    />
    <Resource
      name="logs"
      icon={ErrorOutline}
      options={{ label: "Logs" }}
      list={LogsResource.LogsList}
      edit={LogsResource.LogsEdit}
    />
  </Admin>
);

export default App;
